import React, { Component } from "react";

export default class Instructions extends Component {
  render() {
    return (
      <div className="instructions">
        <h3 className="text-center">COVID-19 Vaccine Registration</h3>

        <p>Redlands Community Hospital is committed to supporting the health and wellness of our community. We have partnered with San Bernardino County to provide COVID-19 vaccinations to individuals that qualify according to the current San Bernardino County COVID-19 vaccine Phase allocation.</p>

        <p>Registrations and appointments are currently only available for: <a className="text-white" href="https://sbcovid19.com/vaccine/"><u>Please visit San Bernardino County Vaccine Site</u></a></p>
        

        <h5>Important Note:</h5>
        <p>You MUST bring a valid photo ID as proof of eligibility to be vaccinated. If you do not bring valid identification, your appointment will be rescheduled - no exceptions</p>
      
        <h5>Group Code:</h5>
        <p>This is a private invitation code and will be used to identify reservations eligible for appointments.</p>
        <table className="table text-white">
          <thead>
            <tr>
              <th scope="col">Code</th>
              <th scope="col">Group</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">RCHALL</th>
              <td>All San Bernardino County residents over the age of 18</td>
            </tr>
            <tr>
              <th scope="row">RCHJJ</th>
              <td>Johnson and Johnson Vaccine for San Bernardino County residents over the age of 18</td>
            </tr>
            <tr>
              <th scope="row">URYOUTH</th>
              <td>Pfizer Vaccine for children ages 12-17</td>
            </tr>
            <tr>
              <th scope="row">BHAWKS</th>
              <td>Pfizer Vaccine @ Citrus Valley High School location for children ages 12-17</td>
            </tr>
            <tr>
              <th scope="row">TERRIERS</th>
              <td>Pfizer Vaccine  @Redlands High School location for children ages 12-17</td>
            </tr>
            <tr>
              <th scope="row">WILDCATS</th>
              <td>Pfizer Vaccine @ REV High School location for children ages 12-17</td>
            </tr>
            <tr>
              <th scope="row"></th>
              <td></td>
            </tr>
          </tbody>
        </table>

        <h5>Phone Number:</h5>
        <p>By providing your mobile phone number, you will receive your COVID-19 vaccine appointment information via secure text message. If you have a smart phone (iPhone, Samsung Galaxy, etc), you can also receive and complete your COVID-19 vaccine consent form before arriving at your appointment by using the AxS Health digital app. A link to download the AxS Health app will be included in your appointment text message.</p>
        <p>You can make a reservation and receive an appointment without selecting the mobile phone number option. When your appointment is available, RCH staff will contact you using the phone number you provide.</p>
      </div>
    );
  }
}
